App.controller('InsurerTuzPzuwCtrl', ['$scope', '$sce', '$state', '$stateParams', '$timeout', '$filter', 'pzuwInsurerService', 'branchService', 'Blob', 'FileSaver', function ($scope, $sce, $state, $stateParams, $timeout, $filter, pzuwInsurerService, branchService, Blob, FileSaver) {
    $scope.stateParams = $stateParams;

    $scope.page = 'House_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Ubezpieczyciel';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.current = 0;
    $scope.numberOfPages = 0;
    $scope.pageSize = 10;
    $scope.reports = [];

    branchService.dataBranchLists().then(
        function (data) {
            if (data.status === 200) {
                $scope.pageSize = data.data.data.length;
                loadReports($scope.current);
            }
        }
    );



    function loadReports(page) {
        let criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize
        };

        pzuwInsurerService.getReports(criteria).then(
            function (data) {
                if (data.status === 200) {
                    $scope.reports = data.data.data;
                    $scope.numberOfPages = data.data.pages;
                }
            }
        );
    }

    $scope.pageChanged = function (page) {
        loadReports(page);
        $scope.current = page;
    };

    $scope.downloadReport = function (ev, value, rehabilitation) {

        let el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

        pzuwInsurerService.downloadReport(value.id, rehabilitation).then(function (data) {
            if (data.status === 200) {
                let blob = new Blob([data.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, $filter('getFileNameFromContentDisposition')(data.headers('Content-Disposition')));
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });

    };

    $timeout(function () {
        if (!$('.menu.menu_insurer').hasClass('open')) {
            $('a[target=".menu_insurer"]').trigger('click');
        }
    }, 100);
}]);